export const CodeError = {
  ERR_US_0003: 'ERR-US-0003',
  ERR_US_0004: 'ERR-US-0004',
  ERR_US_0005: 'ERR-US-0005',
  // The card issuer declined the payment, try another payment method or contact the card issuer
  ERR_BP_0006: 'ERR-BP-0006',
  // The pre-authorized payment was declined, try another payment method or contact the card issuer
  ERR_BP_0022: 'ERR-BP-0022',
  ERR_CS_0002: 'ERR_CS_0002',
  ERR_CS_0008: 'ERR-CS-0008',
  // Cognito errors
  // All errors thrown by our cognito lambda functions will have this error code
  COGNITO_LAMBDA_ERROR_CODE: 'UserLambdaValidationException',
  COGNITO_LAMBDA_USER_NOT_FOUND: 'UserNotFoundException',
  COGNITO_ALIAS_ALREADY_EXISTS: 'AliasExistsException',

  USER_ALREADY_EXISTS: 'UserExistsException',
  USER_AUTHENTICATION_FAILED: 'UserAuthenticationException', // this is a catch all error for all authentication failures
  USER_NOT_FOUND: 'UserNotFoundException',
  PHONE_NUMBER_ALREADY_EXISTS: 'PhoneNumberExistsException',
  // Validation errors
  INVALID_EMAIL_DOMAIN: 'INVALID_EMAIL_DOMAIN',
  INVALID_EMAIL_OR_PHONE: 'INVALID_EMAIL_OR_PHONE',
};
